import RPCClient from 'micro-rpc-client';

const rpc = new RPCClient({
  url: '/rpc',
  sendCredentials: 'same-origin',
});

export default function callRpc(methodName, args) {
  return rpc.call(methodName, args);
}
